import { makeApiRequest } from './api';
export interface IUser {
  id: string;
  tenantId: string;
  email: string;
  firstName: string;
  lastName: string;
  createdAt: string;
  updatedAt: string;
}
export interface AuthResponse {
  user: IUser;
  token: string;
  refreshToken: string;
}

export const emailLogin = async (
  email: string,
  otp: string
): Promise<{
  success: boolean;
  data: AuthResponse;
} | null> => {
  const response = await makeApiRequest<{
    success: boolean;
    data: AuthResponse;
  }>('/auth/login', {
    body: JSON.stringify({
      email,
      otp,
    }),
    method: 'POST',
  });
  return response;
};

/**
 * Ask the API to re-sign the caller's token with their current business roles.
 * Authenticated by the existing (still valid) access token — call it before
 * expiry, or after anything that changes business membership.
 */
export const refreshAuthAccessToken = async (accessToken: string) => {
  const response = await makeApiRequest<{ token: string }>('/auth/token', {
    method: 'POST',
    token: accessToken,
    body: JSON.stringify({}),
  });

  return response;
};

export const loadProfile = async (
  token: string,
  refreshAccessToken: () => Promise<string | null>
) => {
  const response = await makeApiRequest<{
    success: boolean;
    data: IUser;
  }>('/users/profile', {
    token,
    refreshAccessToken,
  });

  return response;
};

export const checkUserExistService = async (email: string) => {
  const response = await makeApiRequest<{
    data?: {
      tenantId: string;
    };
    success: boolean;
  }>('/auth/check-email', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
  return response;
};
